exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SecondaryHeader__header___2mbC_ {\n  height: 90px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 20px;\n  flex-shrink: 0;\n  font-size: 1.3rem; }\n  .SecondaryHeader__header___2mbC_ .SecondaryHeader__back___1Ma5J {\n    color: #A1A4A3;\n    cursor: pointer; }\n  .SecondaryHeader__header___2mbC_ .SecondaryHeader__title___2u2rs {\n    margin-left: 25px;\n    color: #4fd0b3;\n    font-size: 1.2em; }\n", ""]);

// exports
exports.locals = {
	"header": "SecondaryHeader__header___2mbC_",
	"back": "SecondaryHeader__back___1Ma5J",
	"title": "SecondaryHeader__title___2u2rs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Header/Secondary/SecondaryHeader.scss
// module id = 742
// module chunks = 0